import { useEffect, useState } from "react";
import { Phone, Clock, X, ShieldCheck, BadgeCheck } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { COMPANY } from "@/data/site";

const STORAGE_KEY = "usd_popup_shown_v1";

export default function CallNowPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Show once per session, with a small delay so the page paints first
    const alreadyShown = sessionStorage.getItem(STORAGE_KEY);
    if (alreadyShown) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem(STORAGE_KEY, "1");
    }, 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="call-now-popup"
        className="sm:max-w-md p-0 overflow-hidden border-0 bg-transparent shadow-none"
      >
        <div className="relative bg-white border border-slate-200 rounded-md overflow-hidden">
          <div className="bp-grid-dark text-white px-6 py-5 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="pulse-dot" />
              <span className="label-eyebrow text-[#D9BF8C]">Peak Plumbing</span>
            </div>
            <button
              data-testid="call-now-popup-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
              className="text-white/70 hover:text-white transition"
            >
              <X size={18} />
            </button>
          </div>

          <DialogHeader className="px-6 pt-6 pb-2 text-left">
            <DialogTitle className="font-display text-3xl md:text-4xl font-black tracking-tight text-[#1E3A5F]">
              Reach the peak. Skip the wait.
            </DialogTitle>
            <DialogDescription className="text-slate-600 text-base">
              Speak with our office team right now — real people, real answers.
            </DialogDescription>
          </DialogHeader>

          <div className="px-6 pb-6 pt-2">
            <a
              data-testid="call-now-popup-cta"
              href={`tel:${COMPANY.phoneTel}`}
              className="btn-cta w-full inline-flex items-center justify-center gap-3 px-5 py-4 text-lg"
            >
              <Phone size={20} />
              Call Now: {COMPANY.phone}
            </a>

            <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
              <span className="flex items-center gap-1.5">
                <Clock size={14} className="text-orange-500" /> Avg. response &lt; 60 min
              </span>
              <span className="flex items-center gap-1.5">
                <ShieldCheck size={14} className="text-emerald-600" /> Fully Insured
              </span>
              <span className="flex items-center gap-1.5">
                <BadgeCheck size={14} className="text-sky-600" /> Free Estimates
              </span>
            </div>

            <button
              data-testid="call-now-popup-dismiss"
              onClick={() => setOpen(false)}
              className="mt-4 w-full text-center text-sm text-slate-500 hover:text-slate-900 transition py-2"
            >
              No thanks, I'll browse first
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
